import { Wrapper } from './header.styles';

import VendorLogo from './common/vendor_logo';

export default function Header() {
  return (
    <Wrapper>
      <VendorLogo />
    </Wrapper>
  );
}
